import React, { Component, Fragment } from 'react';
import GoogleAdd from '../components/GoogleAdd';
export default class Navbar extends Component {
  render() {
    var navigations = (
      <ul className="nav navbar-nav navbar-left">
        <li>
          <a href="/all-articles">All Articles</a>
        </li>
        <li>
          <a href="/how-much-can-you-get">Calculator</a>
        </li>
        <li>
          <a href="/walkthrough">Walkthrough</a>
        </li>
        <li>
          <a href="/glossary">Glossary</a>
        </li>
        <li>
          <a href="/contact">Contact Us</a>
        </li>
      </ul>
    );

    if (!this.props.homepage) {
      return (
        <Fragment>
          <header className="navbar navbar-inverse white" role="banner">
            <div className="container">
              <div className="navbar-header">
                <button
                  className="navbar-toggle"
                  type="button"
                  data-toggle="collapse"
                  data-target=".bs-navbar-collapse"
                >
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                </button>
                <a href="/" className="navbar-brand" style={{ marginRight: '-20px' }}>
                  PropertyHints
                </a>
              </div>
              <nav
                className="collapse navbar-collapse bs-navbar-collapse"
                role="navigation"
                style={{ paddingTop: '10px' }}
              >
                {navigations}
              </nav>
            </div>
          </header>
          <GoogleAdd />
        </Fragment>
      );
    }

    return (
      <Fragment>
        <header className="navbar navbar-inverse hero" role="banner">
          <div className="container">
            <div className="navbar-header">
              <button className="navbar-toggle" type="button" data-toggle="collapse" data-target=".bs-navbar-collapse">
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>
              <a href="/" className="navbar-brand" style={{ marginRight: '-20px' }}>
                PropertyHints
              </a>
            </div>
            <nav
              className="collapse navbar-collapse bs-navbar-collapse"
              role="navigation"
              style={{ paddingTop: '10px' }}
            >
              {navigations}
            </nav>
          </div>
        </header>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navbar.jsx